<template>
  <div class="dashboard">
    <div class="switch-row">
      <button class="switch-btn active">on going process</button>
      <button class="switch-btn">all process</button>
    </div>
    <div class="dashboard-table">
      <div class="latest-update">
        <div class="table">
          <router-link to="/dashboard/recruiting-process/details"
            ><b-table
              hover
              small
              :fields="fields"
              :items="items"
              responsive="sm"
            >
              <template #head(date)>
                <span class="custom-label">
                  Submitted Date<br />Updated Date</span
                >
              </template>
              <template #cell(status)="data">
                <div class="status-info">
                  <span class="circle"></span>
                  <span class="text">{{ data.value }}</span>
                </div>
              </template>
              <template #cell(date)="data">
                <div class="date">
                  <div class="submit">
                    {{ data.value.submit }} {{ data.value.time }}
                  </div>
                  <div class="update">
                    {{ data.value.submit }} {{ data.value.time }}
                  </div>
                </div>
              </template>
              <template #cell(name)="data">
                <div class="candidate-name">
                  {{ data.value.first }} {{ data.value.last }}
                </div>
              </template>
              <template #cell(job)="data">
                <div class="job">
                  <span class="id">Job ID: {{ data.value.jid }}</span>
                  <span class="position"
                    >Position: {{ data.value.jposition }}</span
                  >
                  <span class="company"
                    >Company: {{ data.value.jcompany }}</span
                  >
                </div>
              </template>
            </b-table></router-link
          >
          <Pagination />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/ui/Pagination";
export default {
  name: "DashboardTable",
  components: {
    Pagination,
  },
  data() {
    return {
      fields: [
        { key: "status", label: "Status" },
        { key: "date" },
        { key: "name", label: "Candidate Name" },
        { key: "job", label: "Job" },
      ],
      items: [
        {
          status: "reviewing",
          date: { submit: "04/02/2021", time: "10:00" },
          name: { first: "John", last: "Doe" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "reviewing",
          date: { submit: "04/02/2021", time: "10:00" },
          name: { first: "Kanitta", last: "Chunchua" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "reviewing",
          date: { submit: "04/02/2021", time: "10:00" },
          name: { first: "Kanitta", last: "Chunchua" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "reviewing",
          date: { submit: "04/02/2021", time: "10:00" },
          name: { first: "Kanitta", last: "Chunchua" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "reviewing",
          date: { submit: "04/02/2021", time: "10:00" },
          name: { first: "Kanitta", last: "Chunchua" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.switch-row {
  margin-bottom: 2rem;
  .switch-btn {
    font-family: "Poppins", sans-serif;
    background: none;
    border-radius: 100rem;
    padding: 10px 15px;
    border: 1px solid $black;
    color: $black;
    margin-right: 15px;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    &:hover {
      filter: contrast(150%);
    }
    &.active {
      border: 1px solid $blue-primary;
      color: $blue-primary;
    }
  }
}
.dashboard-table {
  /deep/.table {
    color: #1a1a1a;
    .table-hover tbody tr:hover {
      background-color: #fafafa;
      color: $black;
    }
    table {
      thead {
        tr {
          font-size: 1em;
          font-weight: 700;
          padding: 1rem;

          th {
            border: 0;
            padding-bottom: 1rem;
            vertical-align: baseline;
            div {
              font-weight: 700;
            }
          }
        }
        .custom-label {
          font-size: 1em;
          font-weight: 700;
          line-height: 1.5rem;
        }
      }
      tbody {
        transition: all 0.4s ease-in-out;
        tr {
          line-height: normal;
          td {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Helvetica, Arial, sans-serif, "Apple Color Emoji",
              "Segoe UI Emoji", "Segoe UI Symbol";
            font-size: 14px;
            padding: 1rem 0;
          }
        }
      }
    }
  }
  .status-info,
  .date,
  .candidate-name {
    span {
      line-height: normal;
    }
  }
  .status-info {
    align-items: center;
    display: inline-flex;
    margin-left: 1rem;
    .circle {
      background: $status-employed;
      border-radius: 100rem;
      display: inline-block;
      height: 12px;
      margin-right: 8px;
      width: 12px;
    }
    .text {
      color: #787a7a;
      /* stylelint-disable-next-line declaration-no-important */
      font-family: "Poppins", sans-serif !important;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
  .candidate-name {
    font-weight: 700;
  }
  .job {
    span {
      display: block;
      line-height: normal;
      margin-bottom: 2px;
    }
  }
  .table-sm th,
  .table-sm td {
    padding: 1rem 0;
  }
  .link {
    align-items: center;
    color: $blue-primary;
    display: flex;
    flex-direction: row;
    font-size: 1em;
    font-weight: 700;
    justify-content: flex-end;
    padding: 1rem 0;
    transition: all 0.4s ease-in-out;
    &:hover,
    &:focus {
      /* stylelint-disable-next-line declaration-no-important */
      box-shadow: none !important;
      filter: contrast(150%);
      text-decoration: none;
    }
  }
}

@media only screen and (max-width: 991px) {
  .switch-row {
    .switch-btn {
      padding: 8px 10px;
      font-size: 10px;
    }
  }
  .dashboard-table {
    /deep/.table {
      table {
        thead {
          tr {
            font-size: 10px;
            padding: 1rem;
          }
          th {
            line-height: 12px;
            padding-right: 5px;
          }
          .custom-label {
            font-size: 10px;
            line-height: 10px;
          }
        }
        tbody {
          tr {
            td {
              font-size: 10px;
              padding-right: 10px;
            }
          }
        }
      }
    }
    .status-info,
    .date,
    .candidate-name {
      span {
        padding-right: 0;
      }
    }
    .status-info {
      flex-direction: column;
      margin-left: 0;
      .circle {
        height: 10px;
        margin-bottom: 4px;
        margin-right: 0;
        width: 10px;
      }
      .text {
        font-size: 8px;
        line-height: 10px;
        margin-top: 2px;
        text-align: center;
      }
    }
    .date {
      font-size: smaller;
    }
    .job {
      font-size: smaller;
    }
    .table-sm th,
    .table-sm td {
      padding: 0.5rem 0;
    }
    .link {
      font-size: 12px;
    }
  }
}
</style>
